import { Send, Timer, Bookmark, ImagePlus, Mic, PlayCircle, MessagesSquare, GalleryHorizontalEnd, Film, Type, Image, Video, Music, ExternalLink } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type NodeType = 'message' | 'delay' | 'photo' | 'audio' | 'video' | 'photo_template' | 'video_template' | 'message_template' | 'tag' | 'go_to';

export interface NodeOption {
    type: NodeType;
    icon: LucideIcon;
    label: string;
    description: string;
    color: string;
}

export interface NodeCategory {
    title: string;
    description: string;
    nodes: NodeOption[];
}

export const nodeCategories: NodeCategory[] = [
    {
        title: 'Templates',
        description: 'Mensagens com opções avançadas',
        nodes: [
            {
                type: 'message_template',
                icon: MessagesSquare,
                label: 'Template de Mensagem',
                description: 'Mensagem com botões',
                color: 'bg-blue-500',
            },
            {
                type: 'photo_template',
                icon: GalleryHorizontalEnd,
                label: 'Template de Foto',
                description: 'Foto + título + botões',
                color: 'bg-cyan-500',
            },
            {
                type: 'video_template',
                icon: Film,
                label: 'Template de Vídeo',
                description: 'Vídeo + botões',
                color: 'bg-pink-500',
            },
        ],
    },
    {
        title: 'Mídia Simples',
        description: 'Enviar arquivos sem formatação',
        nodes: [
            {
                type: 'photo',
                icon: ImagePlus,
                label: 'Foto',
                description: 'Enviar apenas uma foto',
                color: 'bg-indigo-500',
            },
            {
                type: 'audio',
                icon: Mic,
                label: 'Áudio',
                description: 'Enviar áudio ou nota de voz',
                color: 'bg-teal-500',
            },
            {
                type: 'video',
                icon: PlayCircle,
                label: 'Vídeo',
                description: 'Enviar apenas um vídeo',
                color: 'bg-rose-500',
            },
        ],
    },
    {
        title: 'Controles e Ações',
        description: 'Gerenciar fluxo e organização',
        nodes: [
            {
                type: 'message',
                icon: Send,
                label: 'Mensagem',
                description: 'Mensagem de texto simples',
                color: 'bg-blue-500',
            },
            {
                type: 'delay',
                icon: Timer,
                label: 'Aguardar',
                description: 'Pausar antes de continuar',
                color: 'bg-amber-500',
            },
            {
                type: 'tag',
                icon: Bookmark,
                label: 'Tag',
                description: 'Adicionar tag ao lead',
                color: 'bg-emerald-500',
            },
            {
                type: 'go_to',
                icon: ExternalLink,
                label: 'Go To',
                description: 'Redirecionar para outro flow',
                color: 'bg-violet-500',
            },
        ],
    },
];

export const nodeNames: Record<NodeType, string> = {
    message: 'Nova Mensagem',
    message_template: 'Mensagem com Botões',
    photo: 'Enviar Foto',
    photo_template: 'Template de Foto',
    video: 'Enviar Vídeo',
    video_template: 'Template de Vídeo',
    audio: 'Enviar Áudio',
    delay: 'Aguardar',
    tag: 'Adicionar Tag',
    go_to: 'Go To',
};

export const nodeConfigs: Record<string, any> = {
    delay: { delay_seconds: 60 },
    tag: { tag_id: null },
    message_template: { buttons: [] },
    photo_template: { buttons: [] },
    video_template: { buttons: [] },
    go_to: { goto_funnel_id: null, goto_trigger_node_id: null },
};

export type BlockType = 'text' | 'image' | 'video' | 'audio';

export interface BlockTypeOption {
    type: BlockType;
    icon: LucideIcon;
    label: string;
    color: string;
}

export const blockTypes: BlockTypeOption[] = [
    { type: 'text', icon: Type, label: 'Texto', color: 'bg-blue-500' },
    { type: 'image', icon: Image, label: 'Foto', color: 'bg-indigo-500' },
    { type: 'video', icon: Video, label: 'Vídeo', color: 'bg-rose-500' },
    { type: 'audio', icon: Music, label: 'Áudio', color: 'bg-teal-500' },
];
